{
  "MMM Do YYYY, h:mm a": "D MMM YYYY, HH:mm",
  "MMM Do YYYY": "D MMM YYYY",
  "Wedding": "Mariage",
  "Funeral": "Obsèques",
  "Birthday": "Anniversaire",
  "School": "École",
  "Sport": "Sport",
  "event type|Other": "Autre",
  "Audio/video professional": "Spécialiste de l’audiovisuel",
  "Funeral home owner or director": "Responsable de pompes funèbres",
  "Event planner or venue manager": "Spécialiste de l’événementiel ou responsable de salle",
  "Church, pastor, preacher or minister": "Église, pasteur, prédicateur ou ministre du culte",
  "Teacher or school manager": "Enseignement ou direction d’école",
  "Nonprofit or charity": "Association à but non lucratif ou organisme caritatif",
  "Live event streamer or producer": "Diffusion ou production d’événements en direct",
  "role|Other": "Autre",
  "room noun|room": "salle",
  "room noun|stage": "scène",
  "room noun|track": "piste",
  "room noun|court": "court",
  "room noun|field": "terrain",
  "room noun|hall": "hall",
  "room noun|camera": "caméra",
  "Sorry, we need camera roll permissions to make this work!": "Désolés, nous avons besoin d’accéder à vos photos pour que cela fonctionne !",
  "Streaming Permissions Required": "Autorisations de diffusion requises",
  "EventLive cannot open streaming until camera, microphone, and recording permissions are enabled.": "EventLive ne peut pas lancer la diffusion tant que les autorisations de caméra, de micro et d’enregistrement ne sont pas activées.",
  "Search for an event": "Rechercher un événement",
  "Schedule your first service": "Programmez votre première cérémonie",
  "Create your first event": "Créez votre premier événement",
  "Each service gets a private link to share with the family. Families watch on any device, with no app or login.": "Chaque cérémonie a son propre lien privé à partager avec la famille. Les familles regardent sur n’importe quel appareil, sans application ni connexion.",
  "It looks like you have no events at the moment. Create one to see it here": "Vous n’avez aucun événement pour le moment. Créez-en un pour le voir ici",
  "Schedule a Service": "Programmer une cérémonie",
  "Create an Event": "Créer un événement",
  "You have {count} event credit. Each service day uses one.": {
    "one": "Vous avez {count} crédit d’événement. Chaque jour de cérémonie en utilise un.",
    "other": "Vous avez {count} crédits d’événement. Chaque jour de cérémonie en utilise un."
  },
  "You have {count} event credit. Each event day uses one.": {
    "one": "Vous avez {count} crédit d’événement. Chaque jour d’événement en utilise un.",
    "other": "Vous avez {count} crédits d’événement. Chaque jour d’événement en utilise un."
  },
  "You have {count} prepaid event – it will be used for this event.": {
    "one": "Vous avez {count} événement prépayé. Il sera utilisé pour cet événement.",
    "other": "Vous avez {count} événements prépayés. L’un d’eux sera utilisé pour cet événement."
  },
  "Leave": "Quitter",
  "Keep editing": "Continuer à modifier",
  "Leave without scheduling the service?": "Quitter sans programmer la cérémonie ?",
  "Leave without scheduling the event?": "Quitter sans programmer l’événement ?",
  "Schedule your live fundraiser": "Programmez votre collecte de fonds en direct",
  "Schedule a service": "Programmez une cérémonie",
  "Schedule your first event": "Programmez votre premier événement",
  "Schedule your event": "Programmez votre événement",
  "Next, you'll confirm {organization} as the organization receiving donations. You can change the details later.": "Vous confirmerez ensuite que {organization} est l’organisation qui reçoit les dons. Vous pourrez modifier les détails plus tard.",
  "Next, you'll choose the organization receiving donations. You can change the details later.": "Vous choisirez ensuite l’organisation qui recevra les dons. Vous pourrez modifier les détails plus tard.",
  "The family gets one private link to watch live or later. You can change the details any time.": "La famille reçoit un lien privé pour regarder en direct ou plus tard. Vous pouvez modifier les détails à tout moment.",
  "You can change the details later.": "Vous pourrez modifier les détails plus tard.",
  "Are you sure you want to delete {title} and its {count} stage?": {
    "one": "Voulez-vous vraiment supprimer {title} et sa scène ?",
    "other": "Voulez-vous vraiment supprimer {title} et ses {count} scènes ?"
  },
  "Are you sure you want to delete {title} and its {count} track?": {
    "one": "Voulez-vous vraiment supprimer {title} et sa piste ?",
    "other": "Voulez-vous vraiment supprimer {title} et ses {count} pistes ?"
  },
  "Are you sure you want to delete {title} and its {count} court?": {
    "one": "Voulez-vous vraiment supprimer {title} et son court ?",
    "other": "Voulez-vous vraiment supprimer {title} et ses {count} courts ?"
  },
  "Are you sure you want to delete {title} and its {count} field?": {
    "one": "Voulez-vous vraiment supprimer {title} et son terrain ?",
    "other": "Voulez-vous vraiment supprimer {title} et ses {count} terrains ?"
  },
  "Are you sure you want to delete {title} and its {count} hall?": {
    "one": "Voulez-vous vraiment supprimer {title} et son hall ?",
    "other": "Voulez-vous vraiment supprimer {title} et ses {count} halls ?"
  },
  "Are you sure you want to delete {title} and its {count} camera?": {
    "one": "Voulez-vous vraiment supprimer {title} et sa caméra ?",
    "other": "Voulez-vous vraiment supprimer {title} et ses {count} caméras ?"
  },
  "Are you sure you want to delete {title} and its {count} room?": {
    "one": "Voulez-vous vraiment supprimer {title} et sa salle ?",
    "other": "Voulez-vous vraiment supprimer {title} et ses {count} salles ?"
  },
  "Could not delete event": "Impossible de supprimer l’événement",
  "Are you sure you want to delete {title}?": "Voulez-vous vraiment supprimer {title} ?",
  "This action cannot be undone.": "Cette action est irréversible.",
  "Delete Event": "Supprimer l’événement",
  "Deleting Event...": "Suppression de l’événement...",
  "Delete {camera}": "Supprimer {camera}",
  "How to Go Live": "Comment passer en direct",
  "Guest List & Invite": "Liste d’invités et invitations",
  "Title, Date, Time, Event Link, Uploads": "Titre, date, heure, lien et fichiers",
  "Add Another Camera Angle": "Ajouter un autre angle de caméra",
  "Add a Room, Stage or Track": "Ajouter une salle, une scène ou une piste",
  "Chat": "Chat",
  "Privacy Settings": "Paramètres de confidentialité",
  "Event Branding": "Personnalisation de l’événement",
  "Event Analytics": "Statistiques de l’événement",
  "Expiring soon": "Expire bientôt",
  "Storage expiry": "Expiration du stockage",
  "You're invited to watch {title}": "Nous vous invitons à regarder {title}",
  "Guests use your main link and switch to this camera there. Stream it from its own phone.": "Les invités utilisent votre lien principal et y sélectionnent cette caméra. Diffusez-la depuis son propre téléphone.",
  "Share this link: guests switch between the cameras while they watch. Each camera streams from its own phone.": "Partagez ce lien : les invités passent d’une caméra à l’autre pendant qu’ils regardent. Chaque caméra diffuse depuis son propre téléphone.",
  "Guests use the main link and switch {noun}s on the event page. This {noun} streams with its own key.": "Les invités utilisent le lien principal et changent de {noun} sur la page de l’événement. Cette diffusion a sa propre clé de stream.",
  "Share this link: guests switch {noun}s on the event page. Each {noun} streams with its own key.": "Partagez ce lien : les invités changent de {noun} sur la page de l’événement. Chaque {noun} diffuse avec sa propre clé de stream.",
  "Your event link:": "Lien de votre événement :",
  "{days}-day event:  Unlock with {count} more credit": {
    "one": "Événement sur {days} jours : débloquer avec {count} crédit de plus",
    "other": "Événement sur {days} jours : débloquer avec {count} crédits de plus"
  },
  "Unlock with {count} credit": {
    "one": "Débloquer avec {count} crédit",
    "other": "Débloquer avec {count} crédits"
  },
  "{days}-day event: Unlock with {count} prepaid events": "Événement sur {days} jours : débloquer avec {count} événements prépayés",
  "{days}-day event: Unlock with your prepaid event": "Événement sur {days} jours : débloquer avec votre événement prépayé",
  "Unlock with {count} prepaid events": "Débloquer avec {count} événements prépayés",
  "Unlock with your prepaid event": "Débloquer avec votre événement prépayé",
  "Your private event link is scheduled to expire on {date}. Keep your event page, the video and the guestbook online for 1 more year, or for 10 years.": "Le lien privé de votre événement expirera le {date}. Gardez la page de l’événement, la vidéo et le livre d’or en ligne 1 an de plus, ou pendant 10 ans.",
  "Keep My Memories Online Longer": "Garder mes souvenirs en ligne plus longtemps",
  "Download & View Stats": "Télécharger et voir les statistiques",
  "This Event is in the Secure Archive.": "Cet événement est dans l’Archive sécurisée.",
  "The public streaming period for this event has ended. The streaming link has expired, but the memories are safe in our archive.": "La période de diffusion publique de cet événement est terminée. Le lien de diffusion a expiré, mais les souvenirs sont en sécurité dans nos archives.",
  "Restore this Event": "Restaurer cet événement",
  "Unlock cameras": "Débloquer les caméras",
  "{days}-Day Event: {start} – {end}": "Événement sur {days} jours : {start} – {end}",
  "Expires in {count} day": {
    "one": "Expire dans {count} jour",
    "other": "Expire dans {count} jours"
  },
  "Event is in the Secure Archive": "L’événement est dans l’Archive sécurisée",
  "Extend": "Prolonger",
  "Use credit": "Utiliser un crédit",
  "Use prepaid event": "Utiliser un événement prépayé",
  "Could not unlock the event": "Impossible de débloquer l’événement",
  "Pay As You Go": "Paiement à l’usage",
  "Couldn't schedule the service": "Impossible de programmer la cérémonie",
  "Couldn't schedule the event": "Impossible de programmer l’événement",
  "Service title": "Titre de la cérémonie",
  "e.g. Celebration of Life for Jane Doe": "Ex. : Hommage à Marie Dupont",
  "e.g. Anna & Mark's wedding": "Ex. : Mariage d’Anna et Marc",
  "your-event-link": "votre-evenement",
  "Available": "Disponible",
  "Event type": "Type d’événement",
  "Choose the type of event": "Choisissez le type d’événement",
  "When the service starts": "Début de la cérémonie",
  "When the event starts": "Début de l’événement",
  "Make it a multi-day event": "En faire un événement sur plusieurs jours",
  "Raise donations for a nonprofit": "Collecter des dons pour une association à but non lucratif",
  "Viewers can donate on your event page. You'll choose the organization after the event is created.": "Les spectateurs peuvent faire un don sur la page de votre événement. Vous choisirez l’organisation une fois l’événement créé.",
  "Schedule service": "Programmer la cérémonie",
  "Schedule event": "Programmer l’événement",
  "Event details": "Détails de l’événement",
  "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.": "{room} suit la date, l’heure et les jours de l’événement principal. Modifiez-les depuis celui-ci et chaque {noun} suivra.",
  "Changes here apply to all {noun}s. Extra days are charged per {noun}.": "Les modifications faites ici s’appliquent à chaque {noun}. Les jours supplémentaires sont facturés par {noun}.",
  "Title and location": "Titre et lieu",
  "Test events keep their name.": "Les événements test gardent leur nom.",
  "e.g. St. Mary's Church, Austin": "Ex. : Église Saint-Pierre, Lyon",
  "Links and files": "Liens et fichiers",
  "Shown under the video on your event page: a registry, a donation page, a website or a program.": "Affichés sous la vidéo sur la page de votre événement : une liste de cadeaux, une page de dons, un site web ou un programme.",
  "Event rescheduled": "Événement reprogrammé",
  "Guests will see the new date.": "Les invités verront la nouvelle date.",
  "Couldn't change the date": "Impossible de modifier la date",
  "Event date and time": "Date et heure de l’événement",
  "Choose the event's local date and time": "Choisissez la date et l’heure locales de l’événement",
  "Save date and time": "Enregistrer la date et l’heure",
  "Change Link": "Modifier le lien",
  "Change event link?": "Modifier le lien de l’événement ?",
  "If you've already shared the current link with guests, they won't be able to access the event with the old link anymore. Are you sure you want to proceed?": "Si vous avez déjà partagé le lien actuel avec vos invités, ils ne pourront plus accéder à l’événement avec l’ancien lien. Voulez-vous vraiment continuer ?",
  "Event link changed": "Lien de l’événement modifié",
  "Couldn't change the link": "Impossible de modifier le lien",
  "Share this link with your guests.": "Partagez ce lien avec vos invités.",
  "your-event-name": "nom-de-votre-evenement",
  "Copy event link": "Copier le lien de l’événement",
  "Guests who already have the old link won't be able to open the event with it.": "Les invités qui ont l’ancien lien ne pourront plus l’utiliser pour ouvrir l’événement.",
  "Change link": "Modifier le lien",
  "Edit {title}": "Modifier {title}",
  "Edit link": "Modifier le lien",
  "Add a name": "Ajoutez un nom",
  "Add a web address": "Ajoutez une adresse web",
  "Open {title}": "Ouvrir {title}",
  "Open link": "Ouvrir le lien",
  "Remove {title}": "Retirer {title}",
  "Remove link": "Retirer le lien",
  "File name guests see": "Nom du fichier visible par les invités",
  "Link text": "Texte du lien",
  "e.g. Order of service": "Ex. : Déroulé de la cérémonie",
  "e.g. Our registry": "Ex. : Notre liste de mariage",
  "Web address": "Adresse web",
  "Add link": "Ajouter un lien",
  "File added": "Fichier ajouté",
  "Guests can open it from the event page.": "Les invités peuvent l’ouvrir depuis la page de l’événement.",
  "Removed \"{title}\"": "Vous avez retiré « {title} »",
  "Removed \"link\"": "Vous avez retiré le lien",
  "Tap to undo": "Touchez pour annuler",
  "Uploading…": "Importation…",
  "Upload file": "Importer un fichier",
  "file type|Text": "Texte",
  "file type|Image": "Image",
  "file type|File": "Fichier",
  "Document": "Document",
  "Add the text guests will see.": "Ajoutez le texte que verront les invités.",
  "Add the web address.": "Ajoutez l’adresse web.",
  "Enter an address like zola.com/registry or an email.": "Saisissez une adresse comme zola.com/registry ou un e-mail.",
  "Multi-Day event?": "Événement sur plusieurs jours ?",
  "Days": "Jours",
  "Timezone: {timezone}": "Fuseau horaire : {timezone}",
  "Search timezone...": "Rechercher un fuseau horaire...",
  "Select timezone": "Sélectionnez le fuseau horaire",
  "MMMM D, yyyy h:mm a": "D MMMM YYYY HH:mm",
  "dddd, MMMM D, YYYY": "dddd D MMMM YYYY",
  "ddd, MMM D": "ddd D MMM",
  "Start Time": "Heure de début",
  "Event Date and Local Time": "Date et heure locales de l’événement",
  "Event Date": "Date de l’événement",
  "Select": "Valider",
  "date picker|Choose": "Choisir",
  "date picker|Not available": "Non disponible",
  "date picker|Month": "Mois",
  "date picker|Previous Month": "Mois précédent",
  "date picker|Next Month": "Mois suivant",
  "EEEE, MMMM d, yyyy": "EEEE d MMMM yyyy",
  "Start time": "Heure de début",
  "h:mm aa": "HH:mm",
  "date picker|time": "heure",
  "MMMM d, yyyy h:mm aa": "d MMMM yyyy HH:mm",
  "EEE, MMM d": "EEE d MMM",
  "Hide the event page? Guests won't be able to open it.": "Masquer la page de l’événement ? Les invités ne pourront plus l’ouvrir.",
  "Hide the event page?": "Masquer la page de l’événement ?",
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.": {
    "one": "Les personnes qui ont acheté un billet ne pourront plus regarder la diffusion en direct ni la rediffusion tant que vous n’aurez pas réaffiché la page. {count} personne de votre liste d’invités perdra l’accès.",
    "other": "Les personnes qui ont acheté un billet ne pourront plus regarder la diffusion en direct ni la rediffusion tant que vous n’aurez pas réaffiché la page. {count} personnes de votre liste d’invités perdront l’accès."
  },
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again.": "Les personnes qui ont acheté un billet ne pourront plus regarder la diffusion en direct ni la rediffusion tant que vous n’aurez pas réaffiché la page.",
  "{days}-Day Event: {start}": "Événement sur {days} jours : {start}",
  "This event isn't unlocked yet. Ask an admin of {team}'s account to unlock it.": "Cet événement n’est pas encore débloqué. Demandez à un administrateur du compte de {team} de le débloquer.",
  "Couldn't load {team}'s events. Try again.": "Impossible de charger les événements de {team}. Réessayez.",
  "Switch to my account": "Passer à mon compte",
  "No events yet": "Aucun événement pour l’instant",
  "Events in {team}'s account will show up here.": "Les événements du compte de {team} s’afficheront ici.",
  "Event unlocked": "Événement débloqué",
  "Couldn't unlock this event": "Impossible de débloquer cet événement",
  "{team}'s account may not have enough credits. Ask the account holder to add more.": "Le compte de {team} n’a peut-être pas assez de crédits. Demandez au titulaire du compte d’en ajouter."
}
